// Gaurvshali.jsx
import React, { useState } from 'react';
import { Container, Row, Col, Card, Button } from 'react-bootstrap';

export const Gaurvshali = () => {
  const [activeTab, setActiveTab] = useState('freedom-fighter');

  const styles = {
    pageHeader: {
      background: 'linear-gradient(135deg, var(--saffron-deep) 0%, var(--saffron-dark) 100%)',
      padding: '60px 0 40px',
      marginTop: '75px',
      color: 'var(--white-pure)',
      textAlign: 'center'
    },
    sectionTitle: {
      fontSize: '2.5rem',
      fontWeight: 700,
      color: '#1e1e1e',
      marginBottom: '1rem',
      position: 'relative',
      display: 'inline-block'
    },
    titleUnderline: {
      width: '80px',
      height: '4px',
      backgroundColor: 'var(--saffron-deep)',
      margin: '1rem 0 2rem',
      borderRadius: '2px'
    },
    card: {
      backgroundColor: 'var(--white-pure)',
      border: '1px solid var(--saffron-light)',
      borderRadius: '20px',
      padding: '2rem',
      boxShadow: '0 10px 30px -10px rgba(229, 123, 28, 0.1)',
      transition: 'all 0.3s ease',
      height: '100%'
    },
    timelineItem: {
      position: 'relative',
      padding: '1.5rem 2rem',
      borderLeft: '3px solid var(--saffron-deep)',
      marginLeft: '1rem',
      marginBottom: '1.5rem'
    },
    timelineDot: {
      position: 'absolute',
      left: '-9px',
      top: '1.5rem',
      width: '15px',
      height: '15px',
      borderRadius: '50%',
      backgroundColor: 'var(--saffron-deep)',
      border: '2px solid var(--white-pure)'
    }
  };

  // Freedom Fighter Details
  const freedomFighterData = {
    name: "स्वर्गीय पंडित भगवान दीन शर्मा जी",
    title: "अमर स्वतंत्रता सेनानी",
    birth: "1905 (अनुमानित)",
    death: "1985",
    movement: "भारत छोड़ो आंदोलन, 1942",
    imprisonment: "1941-1947 (6 वर्ष)",
    jail: "जिला कारागार, लखीमपुर खीरी",
    description: "पंडित भगवान दीन शर्मा जी एक प्रखर स्वतंत्रता सेनानी थे, जिन्होंने देश की आज़ादी के लिए अपना सर्वस्व न्योछावर कर दिया। वे महात्मा गांधी के विचारों से प्रेरित होकर स्वतंत्रता संग्राम में कूदे और 1941 से 1947 तक जेल में रहे।"
  };

  // Family Tree Data
  const familyTree = [
    {
      generation: "प्रथम पीढ़ी (दादा)",
      members: [
        { name: "स्व. पंडित गुरुप्रसाद जी", role: "प्रतिष्ठित सरकारी अध्यापक", icon: "fa-chalkboard-teacher", image: "/grandfather.png" }
      ]
    },
    {
      generation: "द्वितीय पीढ़ी (पिता एवं चाचा)",
      members: [
        { name: "पंडित प्रेम शंकर शर्मा", role: "आचार्य जी", icon: "fa-user-tie", image: "/father.jpeg" },
        { name: "स्व. पंडित भगवान दीन शर्मा", role: "अमर स्वतंत्रता सेनानी (अविवाहित)", icon: "fa-star-of-life" }
      ]
    },
    {
      generation: "तृतीय पीढ़ी (वर्तमान)",
      members: [
        { name: "पंडित धीरेंद्र कुमार शर्मा", role: "सनातनी योद्धा एवं जनसेवक", icon: "fa-crown" },
        { name: "पंडित नागेंद्र कुमार शर्मा", role: "सामाजिक कार्यकर्ता", icon: "fa-handshake", image: "/brother.jpeg" }
      ]
    }
  ];

  // Historical Records
  const historicalRecords = [
    { office: "जिला कोषागार, लखीमपुर खीरी", record: "स्वतंत्रता सेनानी पेंशन रिकॉर्ड", year: "1947-1985", icon: "fa-landmark" },
    { office: "निरीक्षक कार्यालय, लखीमपुर खीरी", record: "आधिकारिक स्वतंत्रता सेनानी सूची", year: "1947", icon: "fa-file-contract" },
    { office: "जिला कारागार, लखीमपुर खीरी", record: "कारावास अभिलेख", year: "1941-1947", icon: "fa-gavel" },
    { office: "नगर पंचायत, बरवर", record: "वार्षिक सम्मान रिकॉर्ड", year: "1947-वर्तमान", icon: "fa-medal" }
  ];

  // Awards and Recognition
  const awards = [
    { year: "प्रतिवर्ष", occasion: "15 अगस्त (स्वतंत्रता दिवस)", honor: "तिरंगा सम्मान", description: "नगर पंचायत बरवर द्वारा ससम्मान अभिनंदन" },
    { year: "प्रतिवर्ष", occasion: "26 जनवरी (गणतंत्र दिवस)", honor: "राष्ट्रभक्ति सम्मान", description: "विशेष समारोह में सम्मान" },
    { year: "1985", occasion: "मृत्युोपरांत", honor: "स्वतंत्रता सेनानी सम्मान", description: "तत्कालीन प्रशासन द्वारा विशेष सम्मान" }
  ];

  // Legacy Timeline
  const legacyTimeline = [
    { year: "1905", event: "जन्म", description: "बरवर, जिला लखीमपुर खीरी में जन्म" },
    { year: "1941", event: "गिरफ्तारी", description: "अंग्रेजों द्वारा गिरफ्तार, जिला कारागार में बंद" },
    { year: "1942", event: "भारत छोड़ो आंदोलन", description: "जेल में रहते हुए भी आंदोलन का समर्थन" },
    { year: "1947", event: "मुक्ति", description: "देश आज़ाद होने के बाद कारागार से मुक्ति" },
    { year: "1985", event: "महाप्रयाण", description: "देशभक्ति की विरासत छोड़कर महाप्रयाण" }
  ];

  return (
    <>
      {/* Page Header */}
      <section style={styles.pageHeader}>
        <Container>
          <h1 className="display-3 fw-bold" style={{ color: 'var(--white-pure)' }}>
            <i className="fas fa-landmark me-3"></i>
            गौरवशाली विरासत
          </h1>
          <p className="fs-4" style={{ color: 'var(--saffron-light)' }}>
            स्वतंत्रता सेनानी से सनातनी योद्धा तक की गौरव गाथा
          </p>
        </Container>
      </section>

      {/* Navigation Tabs */}
      <section className="py-4" style={{ backgroundColor: 'var(--white-off)' }}>
        <Container>
          <Row className="justify-content-center">
            <Col md={10}>
              <div className="d-flex flex-wrap justify-content-center gap-3">
                <Button
                  variant={activeTab === 'freedom-fighter' ? 'primary' : 'outline-primary'}
                  onClick={() => setActiveTab('freedom-fighter')}
                  style={{
                    backgroundColor: activeTab === 'freedom-fighter' ? 'var(--saffron-deep)' : 'transparent',
                    borderColor: 'var(--saffron-deep)',
                    color: activeTab === 'freedom-fighter' ? 'var(--white-pure)' : 'var(--saffron-deep)',
                    padding: '0.8rem 2rem',
                    borderRadius: '50px',
                    fontWeight: 600
                  }}
                >
                  <i className="fas fa-star-of-life me-2"></i>
                  स्वतंत्रता सेनानी
                </Button>
                <Button
                  variant={activeTab === 'family-tree' ? 'primary' : 'outline-primary'}
                  onClick={() => setActiveTab('family-tree')}
                  style={{
                    backgroundColor: activeTab === 'family-tree' ? 'var(--saffron-deep)' : 'transparent',
                    borderColor: 'var(--saffron-deep)',
                    color: activeTab === 'family-tree' ? 'var(--white-pure)' : 'var(--saffron-deep)',
                    padding: '0.8rem 2rem',
                    borderRadius: '50px',
                    fontWeight: 600
                  }}
                >
                  <i className="fas fa-tree me-2"></i>
                  वंश वृक्ष
                </Button>
                <Button
                  variant={activeTab === 'records' ? 'primary' : 'outline-primary'}
                  onClick={() => setActiveTab('records')}
                  style={{
                    backgroundColor: activeTab === 'records' ? 'var(--saffron-deep)' : 'transparent',
                    borderColor: 'var(--saffron-deep)',
                    color: activeTab === 'records' ? 'var(--white-pure)' : 'var(--saffron-deep)',
                    padding: '0.8rem 2rem',
                    borderRadius: '50px',
                    fontWeight: 600
                  }}
                >
                  <i className="fas fa-file-alt me-2"></i>
                  ऐतिहासिक अभिलेख
                </Button>
                <Button
                  variant={activeTab === 'awards' ? 'primary' : 'outline-primary'}
                  onClick={() => setActiveTab('awards')}
                  style={{
                    backgroundColor: activeTab === 'awards' ? 'var(--saffron-deep)' : 'transparent',
                    borderColor: 'var(--saffron-deep)',
                    color: activeTab === 'awards' ? 'var(--white-pure)' : 'var(--saffron-deep)',
                    padding: '0.8rem 2rem',
                    borderRadius: '50px',
                    fontWeight: 600
                  }}
                >
                  <i className="fas fa-trophy me-2"></i>
                  सम्मान एवं पुरस्कार
                </Button>
              </div>
            </Col>
          </Row>
        </Container>
      </section>

      {/* Freedom Fighter Section */}
      {activeTab === 'freedom-fighter' && (
        <section className="py-5">
          <Container>
            <Row className="g-4">
              <Col lg={5}>
                <div className="position-sticky" style={{ top: '100px' }}>
                  <div className="rounded-4 d-flex align-items-center justify-content-center"
                       style={{ 
                         width: '100%', 
                         height: '400px', 
                         backgroundColor: 'var(--saffron-soft)',
                         border: '4px solid var(--saffron-deep)',
                         borderRadius: '20px'
                       }}>
                    <i className="fas fa-user-shield fa-6x" style={{ color: 'var(--saffron-deep)' }}></i>
                    {/* Replace with: <img src="/images/bhagwan-deen-sharma.jpg" alt="स्वर्गीय पंडित भगवान दीन शर्मा जी" className="img-fluid rounded-4" style={{ width: '100%', height: '100%', objectFit: 'cover' }} /> */}
                  </div>
                  
                  <div className="mt-4 p-4 rounded-4" style={{ backgroundColor: 'var(--saffron-soft)' }}>
                    <h4 className="mb-3" style={{ color: 'var(--saffron-dark)' }}>
                      <i className="fas fa-quote-right me-2" style={{ color: 'var(--saffron-deep)' }}></i>
                      प्रसिद्ध उद्धरण
                    </h4>
                    <p className="fst-italic fs-5">
                      "देश की आज़ादी के लिए अपना सब कुछ न्योछावर कर दिया। जेल की यातनाएँ सही, पर तिरंगे का सम्मान कम नहीं होने दिया।"
                    </p>
                    <p className="text-end mb-0">- पंडित भगवान दीन शर्मा जी</p>
                  </div>
                </div>
              </Col>
              
              <Col lg={7}>
                <h2 className="section-title" style={styles.sectionTitle}>
                  <i className="fas fa-star-of-life me-2" style={{ color: 'var(--saffron-deep)' }}></i>
                  अमर स्वतंत्रता सेनानी
                </h2>
                <div style={styles.titleUnderline}></div>
                
                <Card className="border-0 shadow-sm mb-4">
                  <Card.Body className="p-4">
                    <h1 className="mb-2" style={{ color: 'var(--saffron-dark)' }}>{freedomFighterData.name}</h1>
                    <h4 className="mb-4" style={{ color: '#4f4f4f' }}>{freedomFighterData.title}</h4>
                    
                    <Row className="g-3 mb-4">
                      <Col sm={6}>
                        <div className="p-3 rounded-3" style={{ backgroundColor: 'var(--saffron-soft)' }}>
                          <i className="fas fa-calendar-alt me-2" style={{ color: 'var(--saffron-deep)' }}></i>
                          <strong>जन्म:</strong> {freedomFighterData.birth}
                        </div>
                      </Col>
                      <Col sm={6}>
                        <div className="p-3 rounded-3" style={{ backgroundColor: 'var(--saffron-soft)' }}>
                          <i className="fas fa-calendar-times me-2" style={{ color: 'var(--saffron-deep)' }}></i>
                          <strong>मृत्यु:</strong> {freedomFighterData.death}
                        </div>
                      </Col>
                      <Col sm={6}>
                        <div className="p-3 rounded-3" style={{ backgroundColor: 'var(--saffron-soft)' }}>
                          <i className="fas fa-flag me-2" style={{ color: 'var(--saffron-deep)' }}></i>
                          <strong>आंदोलन:</strong> {freedomFighterData.movement}
                        </div>
                      </Col>
                      <Col sm={6}>
                        <div className="p-3 rounded-3" style={{ backgroundColor: 'var(--saffron-soft)' }}>
                          <i className="fas fa-gavel me-2" style={{ color: 'var(--saffron-deep)' }}></i>
                          <strong>कारावास:</strong> {freedomFighterData.imprisonment}
                        </div>
                      </Col>
                    </Row>
                    
                    <p className="fs-5" style={{ lineHeight: 1.8 }}>{freedomFighterData.description}</p>
                    
                    <div className="mt-4 p-3 rounded-3" style={{ backgroundColor: 'var(--saffron-soft)' }}>
                      <h5 className="mb-3" style={{ color: 'var(--saffron-dark)' }}>
                        <i className="fas fa-landmark me-2"></i>जेल अभिलेख
                      </h5>
                      <p className="mb-2">
                        <i className="fas fa-check-circle me-2" style={{ color: 'var(--saffron-deep)' }}></i>
                        जिला कारागार, लखीमपुर खीरी में 1941 से 1947 तक कठोर कारावास
                      </p>
                      <p className="mb-2">
                        <i className="fas fa-check-circle me-2" style={{ color: 'var(--saffron-deep)' }}></i>
                        जेल नंबर: 427/1941 (जिला कारागार अभिलेख)
                      </p>
                      <p className="mb-0">
                        <i className="fas fa-check-circle me-2" style={{ color: 'var(--saffron-deep)' }}></i>
                        6 वर्ष, 3 माह का कारावास (आधिकारिक रिकॉर्ड)
                      </p>
                    </div>
                  </Card.Body>
                </Card>
                
                {/* Legacy Timeline */}
                <Card className="border-0 shadow-sm">
                  <Card.Body className="p-4">
                    <h4 className="mb-4" style={{ color: 'var(--saffron-dark)' }}>
                      <i className="fas fa-timeline me-2" style={{ color: 'var(--saffron-deep)' }}></i>
                      जीवन यात्रा
                    </h4>
                    
                    {legacyTimeline.map((item, index) => (
                      <div key={index} style={styles.timelineItem}>
                        <div style={styles.timelineDot}></div>
                        <div>
                          <span className="badge mb-2" style={{ backgroundColor: 'var(--saffron-deep)', color: 'white' }}>
                            {item.year}
                          </span>
                          <h5 style={{ color: 'var(--saffron-dark)' }}>{item.event}</h5>
                          <p className="mb-0" style={{ color: '#4f4f4f' }}>{item.description}</p>
                        </div>
                      </div>
                    ))}
                  </Card.Body>
                </Card>
              </Col>
            </Row>
          </Container>
        </section>
      )}

      {/* Family Tree Section */}
      {activeTab === 'family-tree' && (
        <section className="py-5">
          <Container>
            <h2 className="section-title text-center" style={styles.sectionTitle}>
              <i className="fas fa-tree me-2" style={{ color: 'var(--saffron-deep)' }}></i>
              वंश वृक्ष
            </h2>
            <div className="title-underline mx-auto mb-5" style={{ width: '80px', height: '4px', backgroundColor: 'var(--saffron-deep)' }}></div>
            
            <Row className="g-4">
              {familyTree.map((generation, idx) => (
                <Col lg={4} key={idx}>
                  <Card className="border-0 shadow-sm h-100">
                    <Card.Header className="text-center py-3" style={{ backgroundColor: 'var(--saffron-deep)', color: 'white', borderTopLeftRadius: '15px', borderTopRightRadius: '15px' }}>
                      <h4 className="mb-0">{generation.generation}</h4>
                    </Card.Header>
                    <Card.Body className="p-4">
                      {generation.members.map((member, index) => (
                        <div key={index} className={`text-center ${index < generation.members.length - 1 ? 'mb-4' : ''}`}>
                          <div className="rounded-circle d-flex align-items-center justify-content-center mx-auto mb-3 overflow-hidden"
                               style={{ width: '110px', height: '110px', backgroundColor: 'var(--saffron-soft)', border: '3px solid var(--saffron-deep)' }}>
                            {member.image ? (
                              <img
                                src={member.image}
                                alt={member.name}
                                style={{ width: '100%', height: '100%', objectFit: 'cover', objectPosition: 'top center' }}
                              />
                            ) : (
                              <i className={`fas ${member.icon} fa-2x`} style={{ color: 'var(--saffron-deep)' }}></i>
                            )}
                          </div>
                          <h5 style={{ color: 'var(--saffron-dark)' }}>{member.name}</h5>
                          <p className="text-muted">{member.role}</p>
                          {index < generation.members.length - 1 && (
                            <div className="my-3">
                              <i className="fas fa-chevron-down" style={{ color: 'var(--saffron-deep)' }}></i>
                            </div>
                          )}
                        </div>
                      ))}
                    </Card.Body>
                  </Card>
                </Col>
              ))}
            </Row>
            
            <Card className="border-0 shadow-sm mt-4">
              <Card.Body className="p-4">
                <h4 className="text-center mb-4" style={{ color: 'var(--saffron-dark)' }}>
                  <i className="fas fa-info-circle me-2" style={{ color: 'var(--saffron-deep)' }}></i>
                  विशेष जानकारी
                </h4>
                <Row>
                  <Col md={6}>
                    <div className="p-3 rounded-3 mb-3" style={{ backgroundColor: 'var(--saffron-soft)' }}>
                      <i className="fas fa-star-of-life me-2" style={{ color: 'var(--saffron-deep)' }}></i>
                      <strong>स्व. पंडित भगवान दीन शर्मा जी</strong> अविवाहित थे, उन्होंने देश की आज़ादी के लिए अपना पूरा जीवन समर्पित कर दिया।
                    </div>
                  </Col>
                  <Col md={6}>
                    <div className="p-3 rounded-3 mb-3" style={{ backgroundColor: 'var(--saffron-soft)' }}>
                      <i className="fas fa-crown me-2" style={{ color: 'var(--saffron-deep)' }}></i>
                      <strong>पंडित धीरेंद्र कुमार शर्मा</strong> अपने चचेरे बाबा की विरासत को आगे बढ़ा रहे हैं।
                    </div>
                  </Col>
                </Row>
              </Card.Body>
            </Card>
          </Container>
        </section>
      )}

      {/* Historical Records Section */}
      {activeTab === 'records' && (
        <section className="py-5">
          <Container>
            <h2 className="section-title text-center" style={styles.sectionTitle}>
              <i className="fas fa-file-alt me-2" style={{ color: 'var(--saffron-deep)' }}></i>
              ऐतिहासिक अभिलेख
            </h2>
            <div className="title-underline mx-auto mb-5" style={{ width: '80px', height: '4px', backgroundColor: 'var(--saffron-deep)' }}></div>
            
            <Row className="g-4">
              {historicalRecords.map((record, index) => (
                <Col md={6} key={index}>
                  <Card className="border-0 shadow-sm">
                    <Card.Body className="p-4">
                      <div className="d-flex gap-3">
                        <div className="rounded-circle d-flex align-items-center justify-content-center flex-shrink-0"
                             style={{ width: '60px', height: '60px', backgroundColor: 'var(--saffron-soft)', border: '2px solid var(--saffron-deep)' }}>
                          <i className={`fas ${record.icon} fa-2x`} style={{ color: 'var(--saffron-deep)' }}></i>
                        </div>
                        <div>
                          <h4 style={{ color: 'var(--saffron-dark)' }}>{record.office}</h4>
                          <p className="mb-1"><strong>अभिलेख:</strong> {record.record}</p>
                          <p className="mb-1"><strong>वर्ष:</strong> {record.year}</p>
                          <p className="mb-0">
                            <i className="fas fa-check-circle text-success me-1"></i>
                            प्रमाणित एवं दर्ज
                          </p>
                        </div>
                      </div>
                    </Card.Body>
                  </Card>
                </Col>
              ))}
            </Row>
            
            <Card className="border-0 shadow-sm mt-4" style={{ backgroundColor: 'var(--saffron-soft)' }}>
              <Card.Body className="p-4">
                <h4 className="text-center mb-4" style={{ color: 'var(--saffron-dark)' }}>
                  <i className="fas fa-certificate me-2" style={{ color: 'var(--saffron-deep)' }}></i>
                  आधिकारिक प्रमाण पत्र
                </h4>
                <Row className="g-4">
                  <Col md={4}>
                    <div className="text-center p-3 bg-white rounded-3">
                      <i className="fas fa-file-pdf fa-3x mb-2" style={{ color: 'var(--saffron-deep)' }}></i>
                      <p className="mb-0">स्वतंत्रता सेनानी प्रमाण पत्र</p>
                    </div>
                  </Col>
                  <Col md={4}>
                    <div className="text-center p-3 bg-white rounded-3">
                      <i className="fas fa-file-pdf fa-3x mb-2" style={{ color: 'var(--saffron-deep)' }}></i>
                      <p className="mb-0">जेल अभिलेख प्रति</p>
                    </div>
                  </Col>
                  <Col md={4}>
                    <div className="text-center p-3 bg-white rounded-3">
                      <i className="fas fa-file-pdf fa-3x mb-2" style={{ color: 'var(--saffron-deep)' }}></i>
                      <p className="mb-0">सम्मान प्रमाण पत्र</p>
                    </div>
                  </Col>
                </Row>
              </Card.Body>
            </Card>
          </Container>
        </section>
      )}

      {/* Awards Section */}
      {activeTab === 'awards' && (
        <section className="py-5">
          <Container>
            <h2 className="section-title text-center" style={styles.sectionTitle}>
              <i className="fas fa-trophy me-2" style={{ color: 'var(--saffron-deep)' }}></i>
              सम्मान एवं पुरस्कार
            </h2>
            <div className="title-underline mx-auto mb-5" style={{ width: '80px', height: '4px', backgroundColor: 'var(--saffron-deep)' }}></div>
            
            <Row className="g-4">
              {awards.map((award, index) => (
                <Col md={4} key={index}>
                  <Card className="border-0 shadow-sm h-100 text-center">
                    <Card.Body className="p-4">
                      <div className="rounded-circle d-flex align-items-center justify-content-center mx-auto mb-3"
                           style={{ width: '100px', height: '100px', backgroundColor: 'var(--saffron-soft)', border: '3px solid var(--saffron-deep)' }}>
                        {index === 0 && <i className="fas fa-flag fa-3x" style={{ color: 'var(--saffron-deep)' }}></i>}
                        {index === 1 && <i className="fas fa-calendar-alt fa-3x" style={{ color: 'var(--saffron-deep)' }}></i>}
                        {index === 2 && <i className="fas fa-medal fa-3x" style={{ color: 'var(--saffron-deep)' }}></i>}
                      </div>
                      <span className="badge mb-2" style={{ backgroundColor: 'var(--saffron-deep)', color: 'white' }}>{award.year}</span>
                      <h4 style={{ color: 'var(--saffron-dark)' }}>{award.occasion}</h4>
                      <h5 className="mb-2">{award.honor}</h5>
                      <p className="mb-0">{award.description}</p>
                    </Card.Body>
                  </Card>
                </Col>
              ))}
            </Row>
            
            <Card className="border-0 shadow-sm mt-4 text-center">
              <Card.Body className="p-5">
                <i className="fas fa-quote-left fa-3x mb-3" style={{ color: 'var(--saffron-deep)' }}></i>
                <h3 style={{ color: 'var(--saffron-dark)' }}>वार्षिक सम्मान परंपरा</h3>
                <p className="fs-5">
                  प्रतिवर्ष 15 अगस्त एवं 26 जनवरी को नगर पंचायत बरवर के कार्यक्रमों में 
                  स्वतंत्रता सेनानी पंडित भगवान दीन शर्मा जी के परिवार को विशेष रूप से सम्मानित किया जाता है।
                  यह परंपरा 1947 से निरंतर जारी है।
                </p>
              </Card.Body>
            </Card>
          </Container>
        </section>
      )}

      {/* Call to Action */}
      <section className="py-5" style={{ backgroundColor: 'var(--saffron-soft)' }}>
        <Container className="text-center">
          <h2 className="display-5 fw-bold mb-4" style={{ color: 'var(--saffron-dark)' }}>
            विरासत को नमन
          </h2>
          <p className="fs-5 mb-4">
            स्वतंत्रता सेनानियों के बलिदान को सलाम। उनके सपनों का भारत बनाने का संकल्प।
          </p>
          <Button
            href="/"
            className="px-5 py-3 rounded-pill fw-bold border-0"
            style={{ backgroundColor: 'var(--saffron-deep)', color: 'white', fontSize: '1.2rem' }}
            onMouseEnter={(e) => {
              e.target.style.backgroundColor = 'transparent';
              e.target.style.color = 'var(--saffron-deep)';
              e.target.style.border = '2px solid var(--saffron-deep)';
            }}
            onMouseLeave={(e) => {
              e.target.style.backgroundColor = 'var(--saffron-deep)';
              e.target.style.color = 'white';
              e.target.style.border = 'none';
            }}
          >
            <i className="fas fa-home me-2"></i>
            मुखपृष्ठ पर जाएँ
          </Button>
        </Container>
      </section>
    </>
  );
};

export default Gaurvshali;
